import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, FormsModule, InputTextModule, ButtonModule, ToastModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
  providers: [MessageService]
})
export class ForgotPasswordComponent {
  email: string = '';
  constructor(private http: HttpClient, private messageService: MessageService, private router: Router) {}
  onSubmit() {
    this.http.post(`${environment.baseUrl}users/user/forgot-password`, { email: this.email }).subscribe(
      () => {
        this.router.navigate(['/login']);
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Password reset link sent!' });
      },
      () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to send reset link' });
      }
    );
  }
}
